export const CampaignCardPress = ({ press }) => {
  if (!press || press.length === 0) return null;
  return (
    <div className="mt-6 md:mt-8">
      <div className="text-[10px] tracking-[0.22em] uppercase opacity-50 mb-2">
        Coverage & Recognition
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-1.5 text-[11px] md:text-xs tracking-[0.1em] uppercase font-medium">
        {press.map((p, i) => (
          <span key={p} className="opacity-80">
            {p}
            {i < press.length - 1 && (
              <span className="opacity-40 ml-3">·</span>
            )}
          </span>
        ))}
      </div>
    </div>
  );
};
